var convert = require('./convert'),
    func = convert('min', require('../min'), require('./_falseOptions'));

func.placeholder = require('./placeholder');
module.exports = func;



/*****************
 ** WEBPACK FOOTER
 ** ./~/semantic-ui-react/~/lodash/fp/min.js
 ** module id = 4075
 ** module chunks = 0
 **/